import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Chip from '@material-ui/core/Chip';

const ChipStyled = styled(Chip)`
  height: 20px;
  font-size: 12px;
  color: #77C1EC;
  border-color: #77C1EC;
`

const styles = theme => ({
  root: {
  },
  chip: {
    marginRight: theme.spacing.unit,
  },
});

const Chips = ({
  array,
  classes,
  theme,
  ...other
}) => {

  const chips = () => {
    return array.map((item, index) => (
      <ChipStyled key={`chip-${index}`} label={item} className={classes.chip} variant="outlined" />
    ))
  }
  
  return (
    <div className={classes.root}>
      {chips()}
    </div>
  )
}

Chips.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  array: PropTypes.array,
};

Chips.defaultProps = {
  array: [],
};

export default withStyles(styles, { withTheme: true })(Chips);
